export const PWA_PROMPT_STORAGE_KEYS = {
  publicationInstall: 'pwaPromptShown',
  publicationInstalled: 'pwaInstalled',
  communityInstall: 'communityPwaPromptShown',
  communityInstallCallout: 'communityPwaInstallCalloutDismissed',
  // "Remind me later" for the desktop callout: a 30-minute timed local dismissal (cross-tab).
  communityInstallCalloutVisit: 'communityPwaInstallCalloutVisitDismissed',
  communityInstalled: 'communityPwaInstalled',
  publicationPush: 'enablePushNotificationPromptShown',
  communityPush: 'communityEnablePushNotificationPromptShown',
} as const;

export const isPublicationHomePath = (pathname: string): boolean => pathname === '/';

export const isCommunityInstallPath = (pathname: string): boolean =>
  pathname === '/community' || pathname.startsWith('/community/');

export const isStandaloneDisplayMode = (displayMode: string): boolean =>
  displayMode === 'standalone' || displayMode === 'fullscreen';
